module.exports = {title:'How much would you like to collectively raise?'}